// ******  THIS FILE IS MARKED FOR DEPRECATION! ******
// Please prefer `./components/Stack` `./components/Divider`
// `./components/Typography` and `./hooks/useThemeColor` over the
// `View` `Divider` and `Text` properties in this file.
import { Text as DefaultText } from 'react-native';

import useThemeColorHook from '@lib/hooks/useThemeColor';

import Divider_ from './Divider';
import Stack from './Stack';

type ThemeProps = {
    lightColor?: string;
    darkColor?: string;
};

export type TextProps = ThemeProps & DefaultText['props'];
export const View = Stack;
export const Divider = Divider_;
export const useThemeColor = useThemeColorHook;
